import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'sls_ops_log_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isPdm());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/PdmPerimeter.js